import React, { useState, useEffect } from "react";
import { setMfaEnabled } from "../api/mfa";
import { useAuth } from "../context/AuthContext";
import { api } from "../api/index";

const MfaToggle: React.FC = () => {
  const { getUserIdFromToken, getCsrfToken } = useAuth();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{ text: string; ok: boolean } | null>(null);
  const [confirmDisable, setConfirmDisable] = useState(false);
  const [enabled, setEnabled] = useState<boolean>(false);

  // Busca o estado atual de MFA do backend ao montar o componente
  useEffect(() => {
    const fetchMfaStatus = async () => {
      const userId = getUserIdFromToken();
      const token = getCsrfToken();
      if (!userId || !token) return;
      try {
        const response = await api.get(`/users/${userId}`, {
          headers: { "X-CSRF-Token": token },
        });
        setEnabled(response.data?.mfa_enabled ?? false);
      } catch {
        // mantém false em caso de erro
      }
    };
    fetchMfaStatus();
  }, [getUserIdFromToken, getCsrfToken]);

  const clearMsg = () => setTimeout(() => setMessage(null), 5000);

  const toggle = async (newValue: boolean) => {
    const userId = getUserIdFromToken();
    const token = getCsrfToken();
    if (!userId || !token) return;
    setLoading(true);
    try {
      const result = await setMfaEnabled(userId, newValue, token);
      setEnabled(result.mfa_enabled);
      setMessage({
        text: result.mfa_enabled
          ? "Autenticação de dois fatores ativada. No próximo login você receberá um código no e-mail."
          : "Autenticação de dois fatores desativada.",
        ok: true,
      });
    } catch (err: any) {
      setMessage({
        text:
          err.response?.data?.message ||
          "Erro ao alterar configuração de MFA.",
        ok: false,
      });
    } finally {
      setLoading(false);
      setConfirmDisable(false);
      clearMsg();
    }
  };

  const handleToggle = () => {
    if (enabled) {
      // Pedir confirmação antes de desativar
      setConfirmDisable(true);
    } else {
      toggle(true);
    }
  };

  return (
    <div className="profile-form mt-4">
        <h5 className="fw-semibold mb-3">Autenticação de dois fatores</h5>

        {message && (
          <div
            className={`alert py-2 small ${
              message.ok ? "alert-success" : "alert-danger"
            }`}
          >
            {message.text}
          </div>
        )}

        {confirmDisable ? (
          <div className="d-flex align-items-center gap-2">
            <span className="small text-muted">Desativar?</span>
            <button
              className="btn btn-danger btn-sm"
              onClick={() => toggle(false)}
              disabled={loading}
            >
              {loading ? "Aguarde..." : "Confirmar"}
            </button>
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => setConfirmDisable(false)}
            >
              Cancelar
            </button>
          </div>
        ) : (
          <button
            className={`btn btn-sm ${
              enabled ? "btn-danger" : "btn-primary"
            }`}
            onClick={handleToggle}
            disabled={loading}
          >
            {loading
              ? "Aguarde..."
              : enabled
              ? "Desativar"
              : "Ativar"}
          </button>
        )}
    </div>
  );
};

export default MfaToggle;
